import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import Home from "src/pages/Home";
import UploadFile from "src/pages/files/UploadFile";
import Login from "src/pages/account/Login";
import NotFound from "src/pages/NotFound";
import UploadedFiles from "src/pages/files/UploadedFiles";
import ConvertedFiles from "src/pages/files/ConvertedFiles";
import Channel from "src/pages/channels";
import Videos from "src/pages/videos";
import Video from "src/pages/Video";
import CreateVideo from "src/pages/createVideo";

export default function Router() {
  return (
    <BrowserRouter>
      {/* <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/forgetPassword" element={<ForgetPassword />} />
        <Route path="/" element={<PrivateRoute />}>
          <Route path="/" element={<Home />} />
          <Route path="/giftReports" element={<GiftReports />} />
          <Route path="/voucherReports" element={<VoucherReports />} />
          <Route path="/discountVoucher" element={<DiscountVoucher />} />
          <Route path="/giftVoucher" element={<GiftVoucher />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/changePassword" element={<ChangePassword />} />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes> */}
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<PrivateRoute />}>
          <Route path="/" element={<Home />} />
          <Route
            path="/files/converted-files/:tusFileId"
            element={<ConvertedFiles />}
          />

          <Route path="/files/uploaded-files" element={<UploadedFiles />} />
          <Route path="/channel" element={<Channel />} />
          {/* <Route path="/videos" element={<Videos />} /> */}
          {/* <Route path="/videos/:id" element={<Video />} /> */}
          {/* <Route path="/createVideo" element={<CreateVideo />} /> */}
          <Route path="/files/upload-file" element={<UploadFile />} />
          <Route
            path="/files"
            element={<Navigate to="/files/uploaded-files" replace />}
          />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
